import { ReactComponent as UaFlag } from "@assets/images/icons/ua-lang.svg";
import { ReactComponent as EnFlag } from "@assets/images/icons/en-lang.svg";
import { ReactComponent as RuFlag } from "@assets/images/icons/ru-lang.svg";
import { ReactComponent as EsFlag } from "@assets/images/icons/es-lang.svg";

export const getCountryFlag = (countryCode) => {
    const flags = {
        UA: UaFlag,
        GB: EnFlag,
        ES: EsFlag,
        RU: RuFlag,
    };
    const FlagComponent = flags[countryCode];
    return FlagComponent ? (
        <div style={{ borderRadius: "0.15625rem", overflow: "hidden", display: "inline-block" }}>
            <FlagComponent />
        </div>
    ) : null;
};